<template>
    <div class="news-summary">
        {{ article.Summary }}
    </div>
    <img v-if="article.Media && !extractYoutubeVideoId(article.Media)" :src="article.Media" alt="News Thumbnail" class="news-thumbnail">
    <iframe v-else-if="article.Media && extractYoutubeVideoId(article.Media)" :src="`https://www.youtube.com/embed/${extractYoutubeVideoId(article.Media)}`" class="news-thumbnail" allowfullscreen></iframe>
    <div class="news-meta">
        <p class="news-author">By <router-link :to="`/profiles/${article.Author}`" target="_blank">{{ article.Author }}</router-link> on {{ formatDate(article.CreatedAt) }}</p>
        <div class="news-tags" v-if="article.Games && article.Games.length > 0">
            <span v-for="game in article.Games" :key="game" class="news-tag">
                {{ gameNames.get(game) }}
            </span>
        </div>
    </div>
    <Markdown :source="article.Content" class="news-content"></Markdown>
    <div v-if="article.EditedAt || article.Editor" class="edit-info">
        Edited <span v-if="article.EditedAt">on {{ formatDate(article.EditedAt) }}</span> <span v-if="article.Editor">by <router-link :to="`/profiles/${article.Editor}`" target="_blank">{{ article.Editor }}</router-link></span>
    </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { NewsArticle } from "@/api";
import TimeService from "@/services/TimeService";
import Markdown from 'vue3-markdown-it';

@Component({
    components: {
        Markdown
    }
})
export default class NewsArticleComponent extends Vue {
    @Prop()
    article: NewsArticle | null = null;

    @Prop()
    gameNames: Map<string, string> = new Map<string,string>();

    formatDate(date: string): string {
        return TimeService.iso8601ToShortFormat(date);
    }

    extractYoutubeVideoId(url: string): string | null {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const match = url.match(regex);
        return match ? match[1] : null;
    }
}

</script>
<style lang="scss" scoped>
@use "@/assets/haloruns_vars.scss" as *;

.no-attachment {
    color: gray;
    text-align: center;
    margin-bottom: 1rem;
}

.news-summary {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-style: italic;
    color: gray;
}

.news-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(128, 230, 255, 0.05);
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: 8px;
}

.news-thumbnail {
    width: 100%;
    aspect-ratio: 16/9;
    object-fit: cover;
    margin-bottom: 1rem;
    border-radius: 8px;
}

.news-tags {
    display: flex;
    gap: 0.5rem;
    margin-top: auto;
    overflow-x: auto;
    scrollbar-width: none;
}

.news-tags::-webkit-scrollbar{
    display: none;
}

.news-tag {
    background-color: gray;
    color: white;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.75rem;
    white-space: nowrap;
}

.news-content {
    font-size: 1.5rem;
}

.edit-info {
    margin-top: 1rem;
    font-size: 0.875rem;
    color: gray;
    text-align: right;
}
</style>
